<template>
  <section class="podium">
    <div class="podium__winners">
      <div class="first" :class="data[0].color">
        <p><span>1.</span> {{ data[0].name }}</p>
        <img
          :src="require(`../assets/images/${data[0].image}.png`)"
          :alt="data[0].image"
        />
      </div>
    </div>
    <div class="podium__runners">
      <div class="second" :class="data[1].color">
        <span>2.</span>
        <p>
          {{ data[1].name }}
          <img
            :src="require(`../assets/images/${data[1].image}.svg`)"
            :alt="data[1].image"
          />
        </p>
      </div>
      <div class="third" :class="data[2].color">
        <span>3.</span>
        <p>
          {{ data[2].name }}
          <img
            :src="require(`../assets/images/${data[2].image}.svg`)"
            :alt="data[2].image"
          />
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Podium',
  props: {
    data: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
}
</script>

<style lang="scss">
$desktop: 1440px;
$tablet: 768px;
$mobile: 600px;

.podium {
  padding: 0 8%;
  display: flex;
  @media (max-width: $tablet) {
    padding: 0;
    flex-direction: column;
  }

  .first,
  .second,
  .third {
    border-radius: 30px;
    p {
      font-size: 30px;
      padding: 20px 0 0 20px;
      margin: 0;
      font-weight: 600;
      @media (max-width: $tablet) {
        font-size: 18px;
      }
      @media (max-width: $desktop) {
        font-size: 20px;
      }
      span {
        font-size: 30px;
        @media (max-width: $tablet) {
          font-size: 18px;
        }
        @media (max-width: $desktop) {
          font-size: 20px;
        }
      }
    }
  }
  .first {
    height: 420px;
    img {
      width: 100%;
    }
    @media (max-width: $tablet) {
      height: 300px;
      img {
        width: 100%;
        margin-top: 20px;
      }
    }
  }
  .second,
  .third {
    height: 160px;
    margin-bottom: 20px;
    padding: 20px;
    span {
      font-size: 30px;
      font-weight: 600;
      @media (max-width: $tablet) {
        font-size: 18px;
      }
      @media (max-width: $desktop) {
        font-size: 20px;
      }
    }
    img {
      width: 15%;
      text-align: center;
      margin-left: 20px;
      @media (max-width: $tablet) {
        display: none;
      }
    }
    p {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0;
      padding: 0;
      @media (max-width: $tablet) {
        font-size: 18px;
      }
      @media (max-width: $desktop) {
        font-size: 20px;
      }
    }
    @media (max-width: $tablet) {
      margin-right: 1%;
      height: 100px;
      width: 43%;
    }
  }
  &__winners {
    width: 59%;
    margin-right: 1%;
    @media (max-width: $tablet) {
      width: 100%;
      margin-right: 0;
      margin-bottom: 20px;
    }
  }
  &__runners {
    width: 39%;
    margin-left: 1%;
    @media (max-width: $tablet) {
      width: 87%;
      margin-left: 0;
      display: flex;
    }
  }
}
</style>